import React from 'react';
import { CheckCircle, Folder } from 'lucide-react';
import { FileGifOutlined } from '@ant-design/icons';

export const MACRO_FOLDER_ICONS: Record<string, React.ReactNode> = {
  'macro-ctv': <CheckCircle size={12} />,
  'macro-gif': <FileGifOutlined />,
  'macro-saca-tu-tarjeta': <Folder size={12} />
};

export const getMacroFolderIcon = (sk: string): React.ReactNode => {
  return MACRO_FOLDER_ICONS[sk] || <Folder size={12} />;
};
